__turbopack_context__.v({
  "error": "Infos-module__vKV77q__error",
  "form": "Infos-module__vKV77q__form",
  "formCard": "Infos-module__vKV77q__formCard",
  "formWrap": "Infos-module__vKV77q__formWrap",
  "header": "Infos-module__vKV77q__header",
  "lead": "Infos-module__vKV77q__lead",
  "page": "Infos-module__vKV77q__page",
  "row": "Infos-module__vKV77q__row",
  "submit": "Infos-module__vKV77q__submit",
  "success": "Infos-module__vKV77q__success",
  "title": "Infos-module__vKV77q__title",
});
